import React from 'react';
import { Divider, Typography } from '@material-ui/core';
import {
  ParsedCartData,
  ParsedPlanData,
  PlanErrorKey,
  PlanErrors,
  planErrorMessages,
} from 'src/components/PlanQueue/PlanQueue.types';
import styles from 'src/components/PlanQueue/PlanQueue.styles';

const sectionStyle: React.CSSProperties = {
  minWidth: 135,
  minHeight: 135,
  flex: '0 0 135px',
};

const rowStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'space-evenly',
  alignItems: 'flex-start',
  margin: '0.5rem 0',
};

const listStyle: React.CSSProperties = {
  padding: '0.5rem 0 0.5rem 1.5rem',
};

interface PlanPopoverContentProps {
  assortmentItems: ParsedPlanData;
  allocationItems: ParsedPlanData;
  cartItems: ParsedCartData;
  showAllocation: boolean;
  planErrors: PlanErrors;
}

export const PlanPopoverContent = ({
  assortmentItems,
  allocationItems,
  cartItems,
  showAllocation,
  planErrors,
}: PlanPopoverContentProps) => {
  const renderError = (key: PlanErrorKey) => (
    <div className={styles.popoverErrorMessage}>⚠️ {planErrorMessages[key]}</div>
  );

  const renderAssortment = planErrors.assortment ? (
    renderError(PlanErrorKey.Assortment)
  ) : (
    <ul style={listStyle}>
      <li>
        <div className="list-popover-container">
          <div>Pending: {assortmentItems.pending.length}</div>
        </div>
      </li>
      <li>
        <div className="list-popover-container">
          <div>Processing: {assortmentItems.processing.length}</div>
        </div>
      </li>
      <li>
        <div className="list-popover-container">
          <div>Completed: {assortmentItems.completed.length}</div>
        </div>
      </li>
      <li>
        <div className="list-popover-container">
          <div>Failed: {assortmentItems.failed.length}</div>
        </div>
      </li>
    </ul>
  );

  const renderCart = planErrors.cart ? (
    renderError(PlanErrorKey.Cart)
  ) : (
    <ul style={listStyle}>
      <li>
        <div className="list-popover-container">
          <div>Processing: {cartItems.processing.length}</div>
        </div>
      </li>
      <li>
        <div className="list-popover-container">
          <div>Failed: {cartItems.failed.length}</div>
        </div>
      </li>
    </ul>
  );

  const renderAllocation = planErrors.allocation ? (
    renderError(PlanErrorKey.Allocation)
  ) : (
    <ul style={listStyle}>
      <li>
        <div className="list-popover-container">
          <div>Processing: {allocationItems.processing.length}</div>
        </div>
      </li>
      <li>
        <div className="list-popover-container">
          <div>Completed: {allocationItems.completed.length}</div>
        </div>
      </li>
      <li>
        <div className="list-popover-container">
          <div>Failed: {allocationItems.failed.length}</div>
        </div>
      </li>
    </ul>
  );

  return (
    <div style={{ minWidth: 325 }}>
      <Typography>Status</Typography>
      <div>
        <div style={rowStyle}>
          <section style={sectionStyle}>
            <Typography variant="overline">Assortment</Typography>
            {renderAssortment}
          </section>
          <Divider orientation="vertical" flexItem={true} />
          <section style={sectionStyle}>
            <Typography variant="overline">Cart</Typography>
            {renderCart}
          </section>
        </div>

        {showAllocation ? (
          <React.Fragment>
            <Divider variant="middle" />
            <div style={rowStyle}>
              <section style={sectionStyle}>
                <Typography variant="overline">Allocation</Typography>
                {renderAllocation}
              </section>
              <Divider orientation="vertical" flexItem={true} />
              <section style={sectionStyle}></section>
            </div>
          </React.Fragment>
        ) : null}
      </div>
    </div>
  );
};
